import axios from 'axios';


export default class MotivateAuth {
    constructor(client) {
        this.setConfig(client)
        this.hydrate()
        setInterval(() => {
            this.refreshToken()
        }, 1000*60*15)
    }

    getOauthToken() {
        let token = this.token ? this.token.oauthToken : null
        if (token) {
            return token
        } else {
            this.hydrate()
            this.refreshToken()
        }
    }

    getUser() {
        return this.user
    }

    async logout() {
        let bodyFormData = this.getBodyFormDataBase();
        bodyFormData.set('token', this.token.oauthToken);
        bodyFormData.set('refresh_token', this.token.refreshToken);
        localStorage.removeItem('motivate-token')
        await axios.post(`${this.config.auth.tokenHost}${this.config.auth.revokePath}`, bodyFormData);
        await this.removeTokens();
        localStorage.clear()
        // Should redirefct to login or close app ????? TODO
        window.location = `${this.config.auth.tokenHost}${this.config.auth.logout}?redirect=${this.config.client.redirectUri}`;
        navigator.app.exitApp();
    }

    /**
     * Parses the authorization_code and gets an access and refresh token.
     * Also checks the authentication to init the getUser function
     * @param code: authorization_code
     */
    async login(code) {
        let bodyFormData = this.getBodyFormDataBase();
        bodyFormData.set('code', code);
        bodyFormData.set('grant_type', 'authorization_code');
        console.warn("bodyFormData", bodyFormData)
        try {
            let res = await axios.post(`${this.config.auth.tokenHost}${this.config.auth.tokenPath}`, bodyFormData);
            await this.updateToken(res.data);

            // We just check the authentication to make sure its working + init the getUser
            return await this.checkAuthentication();
        } catch (e) {
            console.error('Oh oh', e)
            return false;
        }
    }


    // Some default body params that are needed
    getBodyFormDataBase() {
        let bodyFormData = new FormData();
        bodyFormData.set('client_id', this.config.client.id);
        bodyFormData.set('redirect_uri', this.config.client.redirectUri);
        bodyFormData.set('scope', this.config.client.scope);
        return bodyFormData;
    }

    getLoginUrl() {
        return `${this.config.auth.tokenHost}${this.config.auth.authPath}?response_type=code&client_id=${this.config.client.id}&redirect_uri=${this.config.client.redirectUri}&state=loginpage&scope=${this.config.client.scope}`;
    }

    // Tries to refresh the access token
    async refreshToken() {
        let bodyFormData = this.getBodyFormDataBase();
        let localToken
        try {
            localToken = JSON.parse(localStorage.getItem('motivate-token'))
        } catch (e) {
            console.log(e)
        }
        let refreshToken = this.token  && this.token.refreshToken ? this.token.refreshToken : localToken.refreshToken
        bodyFormData.set('refresh_token', refreshToken);
        bodyFormData.set('grant_type', 'refresh_token');
        try {
            let res = await axios.post(`${this.config.auth.tokenHost}${this.config.auth.tokenPath}`, bodyFormData);
            await this.updateToken(res.data);
            return res;
        } catch (e) {
            this.removeTokens();
            return false;
        }
    }

    /**
     * Checks if the user is authenticated
     * If there is no oAuth token: then he's clearly not.
     * Else let's try the token my getting the users information.
     *  If working he is authenticated
     *  Else lets try to refresh the token and check this function again to test if it's working now.
     * @param doRefresh: should we try to refresh the access_token if it's not working?
     * @returns { user.me | false }
     */
    async checkAuthentication(doRefresh = true) {
        if (this.token.oauthToken != null) {

            try {
                let user = await axios.get(this.config.api.profile.me, {headers: {authorization: 'Bearer ' + this.token.oauthToken}});
                if (user.status == 401) {
                    window.location = this.getLoginUrl()
                }
                this.user = user.data
                return user;
            } catch (e) {
                console.error(e)
            }
            if (doRefresh && await this.refreshToken()) {
                return this.checkAuthentication(false);
            } else {
                return false;
            }
        } else {
            window.location = this.getLoginUrl();
            return false;
        }
    }

    async updateToken(token) {
        if (token) {
            this.token = {
                oauthToken: token.access_token,
                refreshToken: token.refresh_token
            }
        } else {
            this.token = null
        }
        return this._tokenChanged()
    }

    // removes the access_token and refresh_token
    async removeTokens() {
      return  await this.updateToken(null);

    }

    async _tokenChanged() {
        if (this.token) {
            let token = {
                oauthToken: this.token.oauthToken,
                refreshToken: this.token.refreshToken
            }
            return localStorage.setItem('motivate-token', JSON.stringify(token))
        } else {
            // return localStorage.removeItem('motivate-token')
        }
    }

    /**
     * Hydrate this class tokens if available in localstorage
     * @returns {Promise<void>}
     */
    async hydrate() {
        this.user = null
        this.token = {
            oauthToken: null,
            refreshToken: null
        }
        let tokenHydration = localStorage.getItem('motivate-token')
        if (tokenHydration && typeof tokenHydration == 'string') {
            this.token = JSON.parse(tokenHydration)
        }
    }


    async setConfig(client) {
        this.config = {
            ...client,
            auth: {
                tokenHost: 'https://oauth.motivate.nl',
                tokenPath: '/oauth2/token',
                authPath: '/oauth2/auth',
                revokePath: '/oauth2/revoke',
                logout: '/logout'
            },
            api: {
                profile: {
                    me: 'https://api.suite.motivate.nl/v1/profile/me'
                }
            }
        }
    }
}

